import AbstractRequestTask from "./AbstractRequestTask";
import {APIVERSION, URLRECORDINGLIST} from '../RequestManagerConstants';

class SimpleGetRequestTask extends AbstractRequestTask {
  constructor(url, params = {}, showErrorModal = true) {
    super();

    this.url = url;
    this.params = params;
    this.showErrorModal = showErrorModal;
  }

  isValid(data) {
    if (data.errors || !data.response || data.response === 'error') {
        // Nuevas apis versionadas
        if (data.data){
            return true
        }
        return false;
    }
    return true;
  }

  getShowModal() {
    return this.showErrorModal;
  }

  getUrl() {
    if(this.url.includes('user_token') && this.url.includes('player/v1/getmedia')) {
      const user_token = super.getParams().user_token;
      this.url = this.url.replace(/(user_token=)[\w-]*\.[\w-]*\.[\w-]*/, '$1' + user_token)
    }
    return this.url;
  }

  getParams() {
    if (this.url.indexOf(URLRECORDINGLIST) !== -1) {
      const params = {};
      params.api_version = APIVERSION;
      return { ...super.getParams(), ...params,  ...this.params };
    }

    if (this.url.indexOf('/v1/') !== -1 || this.url.indexOf('/v2/') !== -1) {
      const superParams = super.getParams();
      delete superParams.HKS;
      delete superParams.api_version;
      return { ...superParams, ...this.params };
    }

    if (this.params !== null) {
      return { ...super.getParams(), ...this.params };
    }
    return {}
  }

  success(data, b) {
    this.resolve(data);
  }

  getRetriesNumber(){
    return 0; //caso de tracking para que solo envie una vez la peticion y no tenga reintentos TODO checar que en mis contenidos tambien utiliza este task
  }
  parseErrors(err) {
    if (this.showErrorModal) {
      super.parseErrors(err)
    } else {
      return {}
    }
  }
}

export default SimpleGetRequestTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/SimpleGetRequestTask.js